<template>
  <article>
    <div class="filter">
      <div class="filter__item">
        <el-select class="filter__input" size="mini" v-model="filters.sgid" filterable placeholder="请选择">
          <el-option :label="item.title" :value="item.sgid" v-for="(item, index) in goodsLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">订单ID：</div>
        <el-input v-model="filters.soid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">订单号：</div>
        <el-input v-model="filters.orderid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.suid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">商品名：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">地址：</div>
        <el-input v-model="filters.address" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
    </div>
    <div class="filter mt-10">
      <div class="filter__item">
        <div class="filter__name">快递单号：</div>
        <el-input v-model="filters.express_id" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">时间：</div>
        <el-date-picker v-model="filters.dateTime" type="datetimerange" placeholder="选择时间范围" align="right" size="mini" class="date">
        </el-date-picker>
      </div>
      <button class="blue-small-btn mr-20" @click="download()">导出数据</button>
      <button class="blue-small-btn mr-20" @click="multiExpressDialog = !multiExpressDialog">上传快递</button>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600">
      <el-table-column prop="sogid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="suid" label="用户ID" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('suid', scope.row.suid)">{{scope.row.nickname}}({{scope.row.suid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="soid" label="订单ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="sub_orderid" label="子订单号" width="" align="center">
      </el-table-column>
      <el-table-column prop="sgid" label="商品" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('sgid', scope.row.sgid)">{{scope.row.title}}({{scope.row.sgid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="商品图" width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.icon" width="60" height="60">
        </template>
      </el-table-column>
      <el-table-column prop="total_price" label="总金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="count" label="商品数量" width="" align="center">
      </el-table-column>
      <el-table-column prop="min_price" label="成本价" width="" align="center">
      </el-table-column>
      <el-table-column prop="price" label="单价" width="" align="center">
      </el-table-column>
      <el-table-column prop="post" label="运费" width="" align="center">
      </el-table-column>
      <el-table-column prop="express_id" label="快递单号" width="" align="center">
      </el-table-column>
      <el-table-column prop="address" label="地址" width="" align="center">
      </el-table-column>
      <el-table-column prop="f_commission" label="师傅佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="gf_commission" label="师公佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="an_commission" label="师祖佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="ship_time" label="发货时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.ship_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="receipt_time" label="收货时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.receipt_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="finish_time" label="完成时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.finish_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex">
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="批量快递上传" :visible.sync="multiExpressDialog" size="tiny" width="600px" center>
      <div class="flex fdc aic">
        <div class="dataForm">
          <div class="dataForm__item"> 格式:子订单,快递单号（第一行标题，第二行数据开始）</div>
          <el-upload
            class="upload-demo"
            drag
            action=""
            :limit="1"
            accept=".xls,.xlsx"
            :http-request="shopOrderGoodsUpload"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传.xls和.xlsx文件</div>
          </el-upload>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {shopGoodsLists, shopOrderGoodsLists, shopOrderGoodsEdit, downloadShopOrderGoods, shopOrderGoodsUpload} from '../../../api/api'
export default {
  name: 'shopOrderGoodsList',
  mixins: [mixinList],
  data () {
    return {
      filters: {
        p: 1,
        l: 20,
        total: 0,
        sgid: '',
        suid: '',
        soid: '',
        title: '',
        address: '',
        orderid: '',
        express_id: '',
        dateTime: '',
        start_time: '',
        end_time: '',
        status: -1
      },
      goodsLists: [],
      lists: [],
      listLoading: false,
      multiExpressDialog: false,
      dialog: false
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
      this.getList()
    },
    download () {
      let filters = this.filters
      let link = downloadShopOrderGoods + '?download=1'

      if (filters.sgid !== '') {
        link = link + '&sgid=' + filters.sgid
      }

      if (filters.suid !== '') {
        link = link + '&suid=' + filters.suid
      }

      if (filters.title !== '') {
        link = link + '&title=' + filters.title
      }

      if (filters.address !== '') {
        link = link + '&address=' + filters.address
      }

      if (filters.express_id !== '') {
        link = link + '&express_id=' + filters.express_id
      }

      if (filters.status !== '') {
        link = link + '&status=' + filters.status
      }

      if (filters.start_time !== '') {
        link = link + '&start_time=' + filters.start_time
      }

      if (filters.end_time !== '') {
        link = link + '&end_time=' + filters.end_time
      }

      window.open(link, 'a')
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.sgid !== '') {
        params.sgid = filters.sgid
      }
      if (filters.suid !== '') {
        params.suid = filters.suid
      }
      if (filters.soid !== '') {
        params.soid = filters.soid
      }
      if (filters.title !== '') {
        params.title = filters.title
      }
      if (filters.address !== '') {
        params.address = filters.address
      }
      if (filters.orderid !== '') {
        params.orderid = filters.orderid
      }
      if (filters.express_id !== '') {
        params.express_id = filters.express_id
      }
      if (filters.status !== -1) {
        params.status = filters.status
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      this.listLoading = true
      shopOrderGoodsLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    changeOrderGoodsinfo (index, oper) {
      let status = this.lists[index].status
      let suid = this.lists[index].suid

      if (oper === 2) {
        status = this.lists[index].status === 1 ? 0 : 1
      }

      let params = {
        status: status,
        suid: suid
      }
      shopOrderGoodsEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    dateTimeChange () {
      if (this.filters.dateTime) {
        this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
        this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
      } else {
        this.filters.start_time = ''
        this.filters.end_time = ''
      }
    },
    getGoodsLists () {
      let params = {
      }

      this.listLoading = true
      shopGoodsLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.goodsLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.sgid + ')',
              sgid: item.sgid
            }
          })
          this.goodsLists.unshift({
            title: '所有',
            sgid: ''
          })
        }
      })
    },
    shopOrderGoodsUpload (params) {
      let file = params.file

      // 使用FormData传参数和文件
      let form = new FormData()

      // 添加键值对
      form.append('file', file)

      shopOrderGoodsUpload(form).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
          this.multiExpressDialog = false
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    this.getGoodsLists()
    this.getList()
  },
  watch: {
    'filters.sgid': 'getList',
    'filters.suid': 'getList',
    'filters.soid': 'getList',
    'filters.title': 'getList',
    'filters.address': 'getList',
    'filters.express_id': 'getList',
    'filters.orderid': 'getList',
    'filters.dateTime': 'dateTimeChange',
    'filters.start_time': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopOrderGoodsList.vue